module.exports = __webpack_public_path__ + "img/20190827144016423.5d8a62f0.jpg";